import React, { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";

import { Modal, Input, Form } from "antd";
import { AiOutlineMail, AiOutlineUser } from "react-icons/ai";

import {
  auth,
  logInWithEmailAndPassword,
  signInWithGoogle,
  registerWithEmailAndPassword,
} from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import "antd/dist/antd.css";

function Navigation() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [user, loading, error] = useAuthState(auth);

  const [isModalLoginOpen, setIsModalLoginOpen] = useState(false);
  const [isModalRegisOpen, setIsModalRegisOpen] = useState(false);

  const [form] = Form.useForm();

  //modal login
  const showModalLogin = () => {
    setIsModalLoginOpen(true);
  };

  const handleOkLogin = () => {
    setIsModalLoginOpen(false);
  };

  const handleCancelLogin = () => {
    setIsModalLoginOpen(false);
  };

  //modal register
  const showModalRegis = () => {
    setIsModalRegisOpen(true);
  };

  const handleOkRegis = () => {
    setIsModalRegisOpen(false);
  };

  const handleCancelRegis = () => {
    setIsModalRegisOpen(false);
  };

  const handleChangeSearch = (e) => {
    setData(e.target.value);
  };

  const onSubmitSearch = () => {
    navigate(`/search/${data}`);
  };

  const onFinishLogin = async (values) => {
    // dispatch(onLogin(values));
    // const dataLoad = {
    //   email: values.email,
    //   password: values.password,
    // };
    await logInWithEmailAndPassword(values.email, values.password);
    setIsModalLoginOpen(false);
    form.resetFields();
  };

  const onFinishRegis = async (values) => {
    // dispatch(onRegister(values));
    // const dataLoad = {
    //   name: values.name,
    //   email: values.email,
    //   password: values.password,
    // };
    registerWithEmailAndPassword(values.name, values.email, values.password);
    setIsModalRegisOpen(false);
    form.resetFields();
  };

  const onFinishLoginGoogle = async () => {
    setIsModalLoginOpen(false);
    await signInWithGoogle();
    window.location.reload();
  };

  const isUserLogin = JSON.parse(localStorage.getItem("token"));
  const name = JSON.parse(localStorage.getItem("name"));
  const image = JSON.parse(localStorage.getItem("image"));

  const logOut = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-between pt-7 px-10 z-10 absolute w-full">
      <img
        src="https://movielist-react-app.netlify.app/static/media/Logo.eeba5c17ddf85f2145e83dd963662921.svg"
        alt="logo"
        onClick={() => navigate("/")}
        className="cursor-pointer"
      />
      <div className="bg-transparent border-solid border-2 border-white rounded-full hover:border-red-300 hover:ring-1 flex items-center px-2 w-[200px] sm:w-[400px] lg:w-[500px]">
        <input
          className="bg-transparent p-2 w-full focus:outline-none placeholder:text-white text-white"
          type="text"
          placeholder="What do you want to watch?"
          onChange={(e) => handleChangeSearch(e)}
        />
        <AiOutlineSearch
          onClick={() => onSubmitSearch()}
          size={25}
          className="text-white hover:text-red-400 cursor-pointer"
        />
      </div>
      <div className="flex items-center">
        {isUserLogin === null ? (
          <>
            <button
              onClick={showModalLogin}
              className="bg-transparent hover:bg-red-500 text-red-500 font-semibold hover:text-white py-2 px-4 border border-red-500 hover:border-transparent rounded-full mr-2"
            >
              Login
            </button>
            <Modal
              title="Log In To Your Account"
              open={isModalLoginOpen}
              onOk={handleOkLogin}
              onCancel={handleCancelLogin}
              footer={null}
            >
              <Form
                name="login"
                className="login-form"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinishLogin}
                form={form}
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your E-mail!",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Email Address"
                    suffix={<AiOutlineMail />}
                    style={{
                      borderRadius: "25px",
                      marginBottom: "0.3rem",
                      padding: "0.5rem 1rem",
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Password"
                    style={{
                      borderRadius: "25px",
                      margin: "0.3rem 0",
                      padding: "0.5rem 1rem",
                    }}
                  />
                </Form.Item>
                <Form.Item>
                  <div className="flex items-center justify-between">
                    <button
                      className="login-form-button bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full mt-4"
                      type="submit"
                    >
                      Login
                    </button>
                    <div className="mt-4">
                      {/* <GoogleLogin
                          onSuccess={(credentialResponse) => {
                            dispatch(dataGoogleLogin(credentialResponse));
                          }}
                          onError={() => {
                            console.log("Login Failed");
                          }}
                          shape="circle"
                        /> */}
                      <button
                        className="login-form-button bg-transparent border border-red-500 text-red-500 hover:text-white hover:bg-red-500 font-bold py-2 px-4 rounded-full"
                        type="submit"
                        onClick={() => onFinishLoginGoogle()}
                      >
                        <div className="flex justify-between items-center">
                          <img
                            className="w-5 h-5 rounded-full mx-auto mr-3"
                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/1200px-Google_%22G%22_Logo.svg.png"
                            alt="google"
                          />
                          Login With Google
                        </div>
                      </button>
                    </div>
                  </div>
                </Form.Item>
              </Form>
            </Modal>
            <button
              onClick={showModalRegis}
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full"
            >
              Register
            </button>
            <Modal
              title="Create Account"
              open={isModalRegisOpen}
              onOk={handleOkRegis}
              onCancel={handleCancelRegis}
              footer={null}
            >
              <Form
                className="regis-form"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinishRegis}
              >
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Name!",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Name"
                    suffix={<AiOutlineUser />}
                    style={{
                      borderRadius: "25px",
                      marginBottom: "0.3rem",
                      padding: "0.5rem 1rem",
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your E-mail!",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Email Address"
                    suffix={<AiOutlineMail />}
                    style={{
                      borderRadius: "25px",
                      margin: "0.3rem 0",
                      padding: "0.5rem 1rem",
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Password"
                    style={{
                      borderRadius: "25px",
                      margin: "0.3rem 0",
                      padding: "0.5rem 1rem",
                    }}
                  />
                </Form.Item>
                <Form.Item>
                  <button
                    type="submit"
                    className="regis-form-button bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full mt-4"
                  >
                    Register
                  </button>
                </Form.Item>
              </Form>
            </Modal>
          </>
        ) : (
          <>
            <div className="bg-transparent  w-full mr-3">
              <div className="flex items-center py-1 px-3">
                <img
                  referrerpolicy="no-referrer"
                  className="w-6 h-6 rounded-full mx-auto"
                  src={
                    image === null
                      ? "https://www.pngall.com/wp-content/uploads/12/Avatar-Profile-Vector-PNG-File.png"
                      : image
                  }
                  alt="avatar"
                />
                <h1 className="text-white pt-1 ml-3">{name}</h1>
              </div>
            </div>
            <button
              onClick={logOut}
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full"
            >
              Logout
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Navigation;
